import React from 'react';
import PropTypes from 'prop-types';

import {Stack, Button, Box} from 'views/components';
import {EmojiBar, MarkdownEditor, MarkdownViewer} from 'views/module';
import {Translate} from 'views/module';

const Message = (props) => {
  const [newMessage, setNewMessage] = React.useState(props.message);
  const [loading, setLoading] = React.useState(false);

  const {
    userRn,
    message,
    truncate,
    editMode,
    onClickSave,
    onClickCancel,
    emojis,
    onEmojiSelected,
    emojisWithRequesterData,
  } = props;

  return (
    <Stack
      sx={{
        py: 0,
      }}
    >
      {
        editMode &&
        <Stack spacing={2}>
          <MarkdownEditor
            value={newMessage}
            onChange={setNewMessage}
            autoFocus
          />
          <Stack direction="row" spacing={1} justifyContent="flex-end">
            <Button variant="outlined" sx={{height: '42px'}} onClick={onClickCancel}>
              <Translate expression='generic.Cancel'/>
            </Button>
            <Button
              sx={{height: '42px'}}
              disabled={loading}
              onClick={(event) => onClickSave(event, newMessage, setLoading)}
              loading={loading}
            >
              <Translate expression='generic.Save' />
            </Button>
          </Stack>
        </Stack>
      }
      {
        !editMode &&
        <MarkdownViewer value={message} truncate={truncate} />
      }
      {
        emojis && Object.values(emojis).length > 0 && (
          <Box
            sx={{my: 1}}
          >
            <EmojiBar
              emojis={emojis || {}}
              emojisWithRequesterData={emojisWithRequesterData || {}}
              requesterRn={userRn}
              onEmojiSelected={onEmojiSelected}
            />
          </Box>
        )
      }
    </Stack>
  );
};

Message.propTypes = {
  userRn: PropTypes.string,
  message: PropTypes.string,
  emojis: PropTypes.object,
  editMode: PropTypes.bool,
  onClickSave: PropTypes.func,
  onClickCancel: PropTypes.func,
  onEmojiSelected: PropTypes.func,
  emojisWithRequesterData: PropTypes.object,
  truncate: PropTypes.bool,
};

export default React.memo(Message);
